import { Component, OnInit, Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CognitoUtil } from '../../../services/cognito.service';
import { AccountService } from '../../../services/account.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-smart-home-dashboard',
  templateUrl: './smart-home-dashboard.component.html',
  styleUrls: ['./smart-home-dashboard.component.css']
})

export class SmartHomeDashboardComponent implements OnInit {
  user: any;
  userFirstName = '';
  userInitials = '';
  authenticated = true;
  display: Boolean = false;
  isSmartHomeRenter: boolean = false;
  smartHomeYardiKey: string = '';
  controllerId: string = '';
  cognitoUtility: CognitoUtil;
  address1: string = '';
  address2: string = '';
  iframeUrl1: SafeResourceUrl;
  iframeUrl2: SafeResourceUrl;
  loadingIFrame1: boolean = false;
  loadingIFrame2: boolean = false;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private accountService: AccountService,
    private cognitoUtil: CognitoUtil,
    public sanitizer: DomSanitizer) {
    const _this = this;

    _this.loadingIFrame1 = true;
    _this.loadingIFrame2 = true;

    if (!localStorage.getItem('UserFirstName') || !localStorage.getItem('UserLastName')) {
      this.user = this.cognitoUtil.getCurrentUser();

      try {
        this.user.getSession(this.getSession.bind(this));
      }
      catch (e) {
        this.authenticated = false;
      }
    }
    else {
      this.userFirstName = localStorage.getItem('UserFirstName');
      const userLastName = localStorage.getItem('UserLastName');
      this.userInitials = this.userFirstName.substr(0, 1) + userLastName.substr(0, 1);
    }
  }

  ngOnInit() {
    const _that = this;
    this.getResidentStatus();

    this.getSmartHomeAccessRights()
      .then(function (result) {
        if (!result) {
          _that.router.navigate(['/leases/non-legacy-leases-dashboard', 'SmartHomeAccessDenied']);
        }
      })
      .catch(function (e) {
        console.log('No SmartHomeAccessRights:', e);
      });

    this.userFirstName = localStorage.getItem('UserFirstName');
    const userLastName = localStorage.getItem('UserLastName');

    if (this.userFirstName && userLastName) {
      this.userInitials = this.userFirstName.substr(0, 1) + userLastName.substr(0, 1);
    }
  }

  getResidentStatus() {
    this.accountService.getResidentStatus()
    .subscribe(res => this.onGetResidentStatusSuccess(res), err => this.accountService.handleError(err));
  }
  onGetResidentStatusSuccess(res){
    if (!res) {
      window.location.href = `https://${environment.triconDomain}.com/resources/smarthome/?utm_source=TriPOD&utm_medium=portal&utm_campaign=smart-home&utm_content=smart-home-info`;
    }
  }

  getBeHomeResidentUrl() {
    const _this = this;
    _this.accountService.getBeHomeResidentUrl().subscribe(function (res: string[]) {
      if (res && res.length > 0) {
        _this.iframeUrl1 = _this.sanitizer.bypassSecurityTrustResourceUrl(res[0]);

        if (res.length > 1) {
          _this.iframeUrl2 = _this.sanitizer.bypassSecurityTrustResourceUrl(res[1]);
        }
      }
    }, err => _this.router.navigate(['/application/dashboard', 'SmartHomeAccessDenied']));
  }

  getSmartHomeAccessRights() {
    const _this = this;

    return new Promise(function (resolve) {
      _this.accountService.getSmarthomeUserStatus().subscribe(function (res) {
        if (res.ResidentHasAccess) {
          _this.isSmartHomeRenter = true;
          _this.getBeHomeResidentUrl();
          if (res.BeHomeDevices.length > 0) {
            _this.address1 = res.BeHomeDevices[0].Address;
            if (res.BeHomeDevices.length > 1) {
              _this.address2 = res.BeHomeDevices[1].Address;
            }
          }
          resolve(true);
        }
        else {
          _this.loadingIFrame1 = false;
          resolve(false);
        }
      });
    });
  }

  getSession(error, sessionData) {
    if (!error) {
      const providerType = localStorage.getItem("ProviderType");
      if (!providerType) {
        this.user.getUserAttributes(this.getUserAttributes.bind(this));
      }
    }
  }

  getUserAttributes(err, attributes) {
    if (!err) {
      const fName = attributes.find(x => x.getName() === 'custom:FirstName').getValue();
      const lName = attributes.find(x => x.getName() === 'custom:LastName').getValue();
      if (fName) {
        this.userFirstName = fName;
        localStorage.setItem('UserFirstName', fName);
      }
      if (lName) {
        localStorage.setItem('UserLastName', lName);
      }

      this.userInitials = fName.substr(0, 1) + lName.substr(0, 1);
    }
  }

  iframe1Loaded() {
    const _this = this;
    _this.loadingIFrame1 = false;
  }

  iframe1Unloaded() {
    const _this = this;
    _this.loadingIFrame1 = true;
  }

  iframe2Loaded() {
    const _this = this;
    _this.loadingIFrame2 = false;
  }

  iframe2Unloaded() {
    const _this = this;
    _this.loadingIFrame2 = true;
  }
}
